import main from './FaqsDocumentationsMain'
import show from './FaqsDocumentationsShow'

export default {
  main,
  show,
}
